import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=6b8b9907&"
import script from "./CallToAction.vue?vue&type=script&lang=js&"
export * from "./CallToAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports